'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

const Separator = React.forwardRef<
	React.ElementRef<typeof SeparatorPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
		/**
		 * Centered text on a horizontal rule ("or" between two ways to sign in). Always
		 * horizontal. Decorative, the word is read as plain text; with `decorative={false}` it
		 * becomes the separator's accessible name, since a separator's own content is not read.
		 */
		label?: string;
	}
>(({ className, orientation = 'horizontal', decorative = true, label, ...props }, ref) =>
	label ? (
		<SeparatorPrimitive.Root
			ref={ref}
			decorative={decorative}
			orientation="horizontal"
			aria-label={decorative ? undefined : label}
			className={cn('flex w-full shrink-0 items-center gap-3 text-xs text-muted-foreground', className)}
			{...props}>
			<span className="h-px flex-1 bg-border" aria-hidden="true" />
			{label}
			<span className="h-px flex-1 bg-border" aria-hidden="true" />
		</SeparatorPrimitive.Root>
	) : (
		<SeparatorPrimitive.Root
			ref={ref}
			decorative={decorative}
			orientation={orientation}
			className={cn('shrink-0 bg-border', orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className)}
			{...props}
		/>
	),
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
